import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-danger mb-1 mt-1",
    role: "alert"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.paymentErrors)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.paymentErrors), 1))
        : _createCommentVNode("", true);
}
